export default __webpack_public_path__ + "static/media/doge-doge-meme.d4358f80.gif";